import { AfterViewInit, Component, EventEmitter, NgZone, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AdjuntoService } from '../../_services/adjunto.service';

import { AppSettings } from '../../../proyect.conf';
import { SocketConexion } from '../../_services/socket-conexion.service';
import jQuery from 'jquery'; import $ from 'jquery';

enum MenuOrientation {
  STATIC,
  OVERLAY
}

@Component( {
  selector: 'app-plantilla',
  templateUrl: 'plantilla.component.html'
} )

export class PlantillaComponent implements AfterViewInit, OnDestroy, OnInit {

  activeTabIndex: number;

  layoutMode: MenuOrientation = MenuOrientation.OVERLAY;

  darkMenu = false;

  topbarMenuActive: boolean;

  sidebarClick: boolean;

  topbarItemClick: boolean;

  activeTopbarItem: any;

  documentClickListener: Function;

  rippleInitListener: any;

  rippleMouseDownListener: any;

  @Output() overlayEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() sidebarActiveEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  sidebarActive: boolean;

  menu: Funcionalidad[] = [];

  carMenu = false;

  usuLogueado: any;

  usuRoles: string[] = [];

  avatar: any;

  rutImagen: any;

  nomUsuario: string;


  constructor( private renderer: Renderer2,
               private zone: NgZone,
               private navService: NavService,
               private autService: AutenticacionService,
               private adjServicio: AdjuntoService,
               private router: Router,
               private socketConexion: SocketConexion
  ) {

    const dataConnect = {
      idUsuario: this.autService.obtenerUsuario().idUsuario,
      nomUsuario: this.autService.obtenerUsuario().usuarioSistema,
      sisUsuario: 'AN',
      uniqueSession: AppSettings.unicaSessionUsuario
    };

    this.socketConexion.socket.emit( 'connectUser', dataConnect );

    this.socketConexion.socket.on( 'uniqueSession', data => {
      if ( data === true ) {
        this.autService.cerrarSesion();
        window.location.href = '/unica-sesion';
      }
    } );

    this.socketConexion.socket.on( 'liberarUsuario', data => {
      if ( data === true ) {
        console.log( 'cerrando sesión...' );
        this.autService.cerrarSesion();
      }
    } );

  }

  ngOnInit() {
    this.navService.getAvatar$.subscribe(
      res => {
        this.avatar = res;
        this.rutImagen = this.avatar;
        this.autService.setImagenAvatar( this.rutImagen );
      } );

    // this.navService.setAvatar( this.autService.obtenerAvatar() );

    const avatar = this.autService.obtenerAvatar();
    if ( avatar !== null && avatar !== undefined && avatar !== '' ) {
      this.adjServicio.descargarArchivo( avatar ).subscribe( adjunto => {
        let reader = new FileReader();
        reader.addEventListener( 'load', () => {
          this.rutImagen = reader.result;
          this.autService.setImagenAvatar( this.rutImagen );
        }, false );
        if ( adjunto ) {
          reader.readAsDataURL( adjunto );
        }
      } );
    }

    this.nomUsuario = this.autService.obtenerNombre();

    this.cargarMenu();
    this.obtenerUsuario();
    this.zone.runOutsideAngular( () => {
      this.bindRipple();
    } );
  }

  bindRipple() {
    this.rippleInitListener = this.init.bind( this );
    document.addEventListener( 'DOMContentLoaded', this.rippleInitListener );
  }

  init() {
    this.rippleMouseDownListener = this.rippleMouseDown.bind( this );
    document.addEventListener( 'mousedown', this.rippleMouseDownListener, false );
  }

  rippleMouseDown( e ) {
    for ( let target = e.target; target && target !== this; target = target[ 'parentNode' ] ) {
      if ( !this.isVisible( target ) ) {
        continue;
      }

      if ( this.selectorMatches( target, '.ripplelink, .p-button' ) ) {
        const element = target;
        this.rippleEffect( element, e );
        break;
      }
    }
  }

  selectorMatches( el, selector ) {
    const p = Element.prototype;
    const f = p[ 'matches' ] || p[ 'webkitMatchesSelector' ] || p[ 'mozMatchesSelector' ] || p[ 'msMatchesSelector' ] || function( s ) {
      return [].indexOf.call( document.querySelectorAll( s ), this ) !== -1;
    };
    return f.call( el, selector );
  }

  isVisible( el ) {
    return !!(el.offsetWidth || el.offsetHeight);
  }

  rippleEffect( element, e ) {
    if ( element.querySelector( '.ink' ) === null ) {
      const inkEl = document.createElement( 'span' );
      this.addClass( inkEl, 'ink' );

      if ( this.hasClass( element, 'ripplelink' ) && element.querySelector( 'span' ) ) {
        element.querySelector( 'span' ).insertAdjacentHTML( 'afterend', '<span class=\'ink\'></span>' );
      } else {
        element.appendChild( inkEl );
      }
    }

    const ink = element.querySelector( '.ink' );
    this.removeClass( ink, 'ripple-animate' );

    if ( !ink.offsetHeight && !ink.offsetWidth ) {
      const d = Math.max( element.offsetWidth, element.offsetHeight );
      ink.style.height = d + 'px';
      ink.style.width = d + 'px';
    }

    const x = e.pageX - this.getOffset( element ).left - (ink.offsetWidth / 2);
    const y = e.pageY - this.getOffset( element ).top - (ink.offsetHeight / 2);

    ink.style.top = y + 'px';
    ink.style.left = x + 'px';
    ink.style.pointerEvents = 'none';
    this.addClass( ink, 'ripple-animate' );
  }

  hasClass( element, className ) {
    if ( element.classList ) {
      return element.classList.contains( className );
    } else {
      return new RegExp( '(^| )' + className + '( |$)', 'gi' ).test( element.className );
    }
  }

  addClass( element, className ) {
    if ( element.classList ) {
      element.classList.add( className );
    } else {
      element.className += ' ' + className;
    }
  }

  removeClass( element, className ) {
    if ( element.classList ) {
      element.classList.remove( className );
    } else {
      element.className = element.className.replace( new RegExp( '(^|\\b)' + className.split( ' ' ).join( '|' ) + '(\\b|$)', 'gi' ), ' ' );
    }
  }

  getOffset( el ) {
    const rect = el.getBoundingClientRect();
    return {
      top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
      left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0),
    };
  }

  unbindRipple() {
    if ( this.rippleInitListener ) {
      document.removeEventListener( 'DOMContentLoaded', this.rippleInitListener );
    }
    if ( this.rippleMouseDownListener ) {
      document.removeEventListener( 'mousedown', this.rippleMouseDownListener );
    }
  }

  ngAfterViewInit() {
    this.documentClickListener = this.renderer.listen( 'body', 'click', ( event ) => {
      if ( !this.topbarItemClick ) {
        this.activeTopbarItem = null;
        this.topbarMenuActive = false;
      }

      if ( !this.sidebarClick && (this.overlay || !this.isDesktop()) ) {
        this.sidebarActive = false;
        this.sidebarActiveEmit.emit( this.sidebarActive );
      }

      this.topbarItemClick = false;
      this.sidebarClick = false;
    } );
  }

  onTabClick( event: Event, index: number ) {
    if ( this.activeTabIndex === index ) {
      this.sidebarActive = !this.sidebarActive;
      this.sidebarActiveEmit.emit( this.sidebarActive );
    } else {
      this.activeTabIndex = index;
      this.sidebarActive = true;
      this.sidebarActiveEmit.emit( this.sidebarActive );
    }

    event.preventDefault();
  }

  closeSidebar( event: Event ) {
    this.sidebarActive = false;
    this.sidebarActiveEmit.emit( this.sidebarActive );
  }

  onSidebarClick( $event ) {
    this.sidebarClick = true;
  }

  onTopbarMenuButtonClick( event ) {
    this.topbarItemClick = true;
    this.topbarMenuActive = !this.topbarMenuActive;
    event.preventDefault();
  }

  onTopbarItemClick( event, item ) {
    this.topbarItemClick = true;
    if ( this.activeTopbarItem === item ) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }
    event.preventDefault();
  }

  onTopbarSubItemClick( event, tipo?: string ) {
    switch ( tipo ) {
      case 'SALIR': {
        this.autService.cerrarSesion();
        window.location.href = '/';
        break;
      }
      case 'ACTPER': {
        this.router.navigate( [ 'ter/miperfil' ] );
        break;
      }
      case 'ACTCON': {
        this.router.navigate( [ 'asi/cambiar-contrasena' ] );
        break;
      }
      default: {
        break;
      }
    }

  }

  get overlay(): boolean {
    this.overlayEmit.emit( this.layoutMode === MenuOrientation.OVERLAY );
    return this.layoutMode === MenuOrientation.OVERLAY;
  }

  changeToStaticMenu() {
    this.layoutMode = MenuOrientation.STATIC;
  }

  changeToOverlayMenu() {
    this.layoutMode = MenuOrientation.OVERLAY;
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  /**
   * Obtiene el usuario logueado
   * @returns {any}
   */
  obtenerUsuario() {
    this.usuLogueado = this.autService.obtenerUsuario();
    this.usuRoles = this.autService.obtenerRolesUsuarios();
  }


  /**
   * Carga el menu.
   */
  cargarMenu() {
    this.carMenu = true;
    this.menu =  this.autService.obtenerMenus();
    this.carMenu = false;
    // Cerrar menu desplues del Clic
    setTimeout( () => {

      jQuery( '.layout-tabmenu-contents .ripplelink' ).click( function() {
        jQuery( '.breadcrumb' ).click( function() {
          console.log( '...clic...' );
        } );
      } );
    }, 1000 );

  }

  irRutas( ruta: string ) {
    switch ( ruta ) {
      case 'DASH': {
        this.router.navigate( [ 'dashboard' ] );
        break;
      }
      default: {
        break;
      }
    }
  }

  ngOnDestroy() {
    if ( this.documentClickListener ) {
      this.documentClickListener();
    }
    this.unbindRipple();
  }


}
